import { render, staticRenderFns } from "./Filtros.vue?vue&type=template&id=776f215c"
import script from "./Filtros.vue?vue&type=script&lang=js"
export * from "./Filtros.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./Filtros.vue?vue&type=custom&index=0&blockType=styles&lang=scss&scoped=true"
if (typeof block0 === 'function') block0(component)

/* hot reload */
if (module.hot) {
  var api = require("C:\\wamp64\\www\\signar-frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('776f215c')) {
      api.createRecord('776f215c', component.options)
    } else {
      api.reload('776f215c', component.options)
    }
    module.hot.accept("./Filtros.vue?vue&type=template&id=776f215c", function () {
      api.rerender('776f215c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/certificados/oficial-registro/Filtros.vue"
export default component.exports